<template>
    <div>
        <div class="table-header row">
            <div>
                <input
                    type="checkbox"
                    v-model="isSelectAll"
                    @change="selectAllChange"
                />
            </div>
            <div>
                网吧名
            </div>
            <div>
                计算机名
            </div>
            <div>
                服务器标签
            </div>
            <div>
                类型
            </div>
            <div>
                分组名
            </div>
            <div>
                在线状态
            </div>
            <div>
                下载状态
            </div>
            <div>
                执行状态
            </div>
            <div>
                最后执行时间
            </div>
        </div>
        <div class="table-body">
            <div
                class="row"
                v-for="(item, index) in barServerList"
                :key="index"
            >
                <!-- 选中 -->
                <div>
                    <input
                        type="checkbox"
                        v-model="item.select"
                        @change="selectChange(item.select)"
                    />
                </div>
                <!-- 网吧名 -->
                <div>
                    <span v-text="item.barName"></span>
                </div>
                <!-- 计算机名 -->
                <div>
                    <span v-text="item.computerName"></span>
                </div>
                <!-- 服务器标签 -->
                <div>
                    <span
                        v-text="$PropFn.safeDislayValue(item.labelName)"
                    ></span>
                </div>
                <!-- 类型 -->
                <div>
                    <span v-if="item.type == 1">主</span>
                    <span v-if="item.type == 0">副</span>
                </div>
                <!-- 分组名 -->
                <div>
                    <span
                        v-text="$PropFn.safeDislayValue(item.groupName)"
                    ></span>
                </div>
                <!-- 在线状态 -->
                <div>
                    <span v-show="item.onlineStatus == 1">在线</span>
                    <span v-show="item.onlineStatus == 0">离线</span>
                </div>
                <!-- 下载状态 -->
                <div>
                    <span v-show="!item.downloadStatus">/</span>
                    <span v-show="item.downloadStatus == 1">下载中</span>
                    <span v-show="item.downloadStatus == 2">下载完成</span>
                    <span v-show="item.downloadStatus == 3">下载失败</span>
                    <span v-show="item.downloadStatus == 5">下载流量不足</span>
                </div>
                <!-- 执行状态 -->
                <div>
                    <span v-show="!item.executionStatus">/</span>
                    <span v-show="item.executionStatus == 1">仅下载不执行</span>
                    <span v-show="item.executionStatus == 2">执行失败</span>
                    <span v-show="item.executionStatus == 3">执行成功</span>
                </div>
                <!-- 最后执行时间 -->
                <div>
                    <span
                        v-text="
                            item.endExecutionTime
                                ? item.endExecutionTime.replace('T', ' ')
                                : '/'
                        "
                    ></span>
                </div>
            </div>
            <no-data
                style="height:auto;padding-top:20px;padding-bottom:20px;"
                v-show="tableList.length == 0 || loading"
                :nodata="tableList.length == 0 && !loading"
                :loading="loading"
            ></no-data>
        </div>
        <div class="table-pagination" v-show="tableList.length > 0">
            <div style="float:left;padding-left:10px;">
                <div
                    class="default-btn"
                    style="margin-left:10px;cursor: pointer;"
                    @click.prevent="selectPageChange"
                >
                    <span>全选本页</span>
                </div>
                <div
                    class="default-btn"
                    style="margin-left:10px;cursor: pointer;"
                    @click.prevent="chooseAllPage"
                >
                    <span>全选所有</span>
                </div>
            </div>
            <page-component
                :total="total"
                :current-page="page"
                @pagechange="pagechange"
            ></page-component>
        </div>
    </div>
</template>

<script>
// 分页功能
import PageComponent from "_c/pagination/pageComponent";
import NoData from "_c/noData/noData";

export default {
    name: "tableData",
    components: {
        PageComponent,
        NoData,
    },
    props: {
        tableList: {
            type: Array,
            default() {
                return [];
            },
        },
        total: {
            type: Number,
            default: 0,
        },
        page: {
            type: Number,
            default: 0,
        },
        loading: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            isSelectAll: false,
            barServerList: [],
            allCheck: false,
        };
    },
    watch: {
        tableList() {
            this.isSelectAll = false;
            this.barServerList = this.tableList.map((item) => {
                item.select = false;
                return item;
            });
            if (this.allCheck) {
                this.isSelectAll = true;
                this.barServerList.forEach((item) => {
                    item.select = true;
                });
            } else {
                var sum = 0;
                this.barServerList.forEach((item) => {
                    if (!item.id) {
                        item.select = false;
                    } else {
                        item.select = true;
                        sum++;
                    }
                });
                sum == this.barServerList.length
                    ? (this.isSelectAll = true)
                    : (this.isSelectAll = false);
            }
        },
    },
    methods: {
        selectedBarIds() {
            let arr = [];
            this.barServerList.forEach((item) => {
                arr.push({
                    barId: item.barId,
                    flag: item.flag,
                    id: item.id,
                    select: item.select ? 1 : 0,
                });
            });
            return arr;
        },
        pagechange(page) {
            this.$emit("pagechange", page, "", "");
        },
        selectAllChange() {
            if (this.isSelectAll) {
                this.barServerList.forEach((item) => {
                    item.select = true;
                });
            } else {
                this.barServerList.forEach((item) => {
                    item.select = false;
                });
            }
            this.allCheck = false;
        },
        selectPageChange() {
            this.isSelectAll = true;
            this.barServerList.forEach((item) => {
                item.select = true;
            });
            this.allCheck = false;
        },
        selectChange(selectState) {
            if (selectState) {
                // 对单项进行选中
                // 判断是否全部选中
                let selectAllState = this.barServerList.every((item) => {
                    return item.select == true;
                });
                // 若全部选中,则为全选状态
                if (selectAllState) {
                    this.isSelectAll = true;
                }
            } else {
                // 对单项进行取消
                this.isSelectAll = false;
            }
            this.allCheck = false;
        },
        chooseAllPage() {
            this.isSelectAll = true;
            this.barServerList.forEach((item) => {
                item.select = true;
            });
            this.allCheck = true;
        },
    },
};
</script>

<style lang="scss" scoped>
@import "_style/table/_default.scss";
@import "_style/cssfn/common.scss";

.row {
    width: 100%;
    cursor: pointer;
    @include clearfix();
    &:after {
        content: "";
        top: 0;
        left: 0;
        display: block;
        font-size: 0;
        height: 0;
        width: 0;
        clear: both;
        visibility: hidden;
    }
    > div {
        float: left;
        text-align: left;
        text-overflow: ellipsis;
        height: 30px;
        span {
            @include ellipsis();
            display: inline-block;
            max-width: 100%;
        }
        p {
            @include ellipsis();
            max-width: 100%;
        }
        a {
            text-align: left;
            text-indent: 0px;
            margin-right: 8px;
            color: #0066cc;
        }
        input {
            cursor: pointer;
        }
    }

    > div:nth-child(1) {
        width: 5%;
        text-indent: 10px;
        input {
            position: relative;
            top: 2px;
        }
    }
    > div:nth-child(2) {
        width: 10%;
    }
    > div:nth-child(3) {
        width: 10%;
    }
    > div:nth-child(4) {
        width: 12%;
    }
    > div:nth-child(5) {
        width: 6%;
    }
    > div:nth-child(6) {
        width: 8%;
    }
    > div:nth-child(7) {
        width: 10%;
    }
    > div:nth-child(8) {
        width: 10%;
    }
    > div:nth-child(9) {
        width: 10%;
    }
    > div:nth-child(10) {
        width: 15%;
    }
}
.table-header {
    border-top: none;
    > div {
        height: 30px;
        line-height: 30px;
    }
}
.table-body,
.table-pagination {
    background: #fff;
}
.table-body {
    border-left: 1px solid rgba(230, 230, 230, 1);
    border-right: 1px solid rgba(230, 230, 230, 1);
    .row {
        height: 30px;
        line-height: 30px;
    }
}

.table-pagination {
    text-align: right;
    border: 1px solid rgba(230, 230, 230, 1);
    border-top: none;
    padding-top: 20px;
    padding-right: 5px;
    > div {
        display: inline-block;
    }
}
input[type="checkbox"] {
    cursor: pointer;
}
</style>
